import { Box, Button, Container, Modal, Typography } from "@mui/material";
import React from "react";
import CheckCircleRoundedIcon from '@mui/icons-material/CheckCircleRounded';

function SuccessModal({ open, onClose, message = null }) {
    // Close modal
    const handleClose = (event, reason) => {
        if (reason !== "backdropClick") {
            onClose(event, reason);
        }
    };

    return (
        <Modal open={open} onClose={handleClose} disableEscapeKeyDown={true}>
            <Box className="box-modal box-modal-xs">
                <div className="box-modal-container">
                    {onClose &&
                        <Button aria-label="exit" className="exit-btn" variant="outlined" onClick={handleClose}>
                            <svg xmlns="http://www.w3.org/2000/svg" width="16" height="16" fill="currentColor" className="bi bi-x" viewBox="0 0 16 16">
                                <path d="M3.854 3.146a.5.5 0 0 1 .708 0L8 7.293l3.438-3.437a.5.5 0 0 1 .708.708L8.707 8l3.439 3.437a.5.5 0 0 1-.708.708L8 8.707l-3.438 3.438a.5.5 0 0 1-.708-.708L7.293 8 3.854 4.562a.5.5 0 0 1 0-.708z" />
                            </svg>
                        </Button>
                    }
                </div>
                <div className="mx-4 d-flex justify-content-center text-center">
                    <CheckCircleRoundedIcon className="icon-ok me-2" />
                    <Typography variant="subtitle1">{message ? message : "Éxito al realizar la solicitud."}</Typography>
                </div>
            </Box>
        </Modal>
    );
}

export default SuccessModal;
